import { memo, useEffect, useRef, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { canDropOnRowDropZone } from '../common/panel-grid';
import { DropZoneRow, DropZoneText } from '../CustomPage.styled';

interface PanelGridRowDropZoneProps {
  readonly rowIndex: number;
  readonly isDragActive?: boolean;
}

const messages = defineMessages({
  dropHere: {
    id: 'customPageDropHere',
    defaultMessage: 'Drop here to create a new row'
  }
});

const PanelGridRowDropZoneComponent = ({ rowIndex, isDragActive = false }: PanelGridRowDropZoneProps) => {
  const intl = useIntl();
  const [isDraggedOver, setIsDraggedOver] = useState(false);
  const zoneRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = zoneRef.current;

    if (!element) {
      return undefined;
    }

    return dropTargetForElements({
      element,
      getData: () => ({ type: 'row-drop-zone', rowIndex }),
      canDrop: ({ source }) => canDropOnRowDropZone(source.data, rowIndex),
      onDragEnter: () => setIsDraggedOver(true),
      onDragLeave: () => setIsDraggedOver(false),
      onDrop: () => setIsDraggedOver(false)
    });
  }, [rowIndex]);

  return (
    <DropZoneRow
      ref={zoneRef}
      $isDragActive={isDragActive}
      $isDraggedOver={isDraggedOver}
      data-testid={`panel-grid-row-drop-zone-${rowIndex}`}
    >
      <DropZoneText $isDragActive={isDragActive}>{intl.formatMessage(messages.dropHere)}</DropZoneText>
    </DropZoneRow>
  );
};

export const PanelGridRowDropZone = memo(PanelGridRowDropZoneComponent);
